"use client";

import React from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogHeaderCentered } from "@shared/src/components/ui/dialog";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { chains } from "@shared/src/config/chains";
import { NETWORK_FAUCET_URLS } from "@shared/src/constants";
import { getNetworkIconUrl } from "@sdk/utils/config";

interface NativeFaucetModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function NativeFaucetModal({ open, onOpenChange }: NativeFaucetModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        size="lg"
        background="primary"
        padding="md"
        position="center-mobile-bottom"
        hideCloseButton={true}
        height="90vh"
        layout="flex-col-overflow"
        className="space-y-4 gap-0 md:h-auto"
      >
        <DialogHeaderCentered
          title="Native Faucet"
          description="Select a network faucet to claim native tokens for gas fees."
          onClose={() => onOpenChange(false)}
        />

        <div className="flex-1 min-h-0 custom-scrollbar overflow-y-auto">
          <div className="flex flex-col gap-2">
            {Object.entries(NETWORK_FAUCET_URLS).map(([chainId, url]) => {
              const network = chains.find(chain => chain.id === Number(chainId));
              return (
                <a
                  key={chainId}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between p-4 bg-surfaces-bg-secondary rounded-xl hover:bg-surfaces-bg-secondary-darker transition-colors"
                >
                  <div className="flex items-center gap-2">
                    {network?.iconUrl && (
                      <img
                        src={getNetworkIconUrl(network?.iconUrl)}
                        alt={network?.name || "Network"}
                        width={24}
                        height={24}
                        className="rounded-full"
                      />
                    )}
                    <span className="font-medium text-text-primary">{network?.name || `Network ${chainId}`}</span>
                  </div>
                  <FaArrowUpRightFromSquare size={14} className="text-text-secondary" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="shrink-0 pt-4">
          <p className="text-text-secondary text-sm text-center">
            You can claim gas tokens directly from these native faucets.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
